import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { createTailoredAuditReason, updateTailoredAuditReason } from "lib/@offline/queued-audits"
import { formatCreateSubjectAudit } from "./lib/format-create-subject-audit"
import { EditAuditReason } from "./edit-audit-reason"

// The justification editor for an intro subject (introduction / its notes). Reuses the shared
// EditAuditReason save flow, but builds a subject-keyed audit (no value diff) instead of a task audit.
export function IntroEditJustification() {
    const {
        justification,
        setJustification,
        subjectId,
        subjectTitle,
        schedule,
        scheduleItem,
        tailoringReferenceId,
        tailoringAudit,
        pendingChange,
    } = useBoundContext()

    return (
        <EditAuditReason
            value={justification}
            setValue={setJustification}
            label="Add justification"
            disabled={pendingChange}
            tailoringAudit={tailoringAudit}
            hasExistingReason={Boolean(tailoringAudit?.payload?.reason)}
            dataCy={`edit-intro-justification-${subjectId}`}
            onBuildAudit={buildAudit}
            onUpdateExisting={updateTailoredAuditReason}
            onCreate={createTailoredAuditReason}
            type="justification"
        />
    )

    function buildAudit(reason) {
        return formatCreateSubjectAudit({
            subjectId,
            subjectTitle,
            tailoringReferenceId,
            schedule,
            scheduleItem,
            reason,
        })
    }
}
